module.exports = __webpack_public_path__ + "img/puberty-decal-13.9ded03a2.png";